import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import LocationAddDialog from "./LocationAddDialog";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import { IconButton } from "@mui/material";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Slide from "@mui/material/Slide";
import AlertOperation from "../commons/AlertOperation";
import { LocationsApi } from "../api/AdminApi";
import { getData } from "../api/AuthenticatedApiCaller";

export default function LocationsView() {
  const [locations, setLocations] = useState(null);
  const [editedLocation, setEditedLocation] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (locations === null || update) {
      fetchData();
      setUpdate(false);
    }
  }, [update]);

  async function fetchData() {
    const [data, error] = await getData(LocationsApi.getAllLocations);
    if (error) {
      // Handle the error
    } else {
      setLocations(data);
    }
  }

  return (
    <Box>

      <Button
        onClick={() => {
          setEditedLocation(null)
          setIsDialogOpen(true)
        }}
        variant="contained"
      >
        Add Location
      </Button>


      <LocationAddDialog
        open={isDialogOpen}
        location={editedLocation}
        save={() => {
          setIsDialogOpen(false);
          setUpdate(true);
        }}
        cancel={() => setIsDialogOpen(false)}
      />


      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="trait table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>International Text</TableCell>
              <TableCell>Greek Text</TableCell>
              <TableCell>Latidue</TableCell>
              <TableCell>Longitude</TableCell>
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations !== null &&
              locations.map((location) => (
                <TableRow id={location.id}>
                  <TableCell>{location.id}</TableCell>
                  <TableCell>{location.multiLangText}</TableCell>
                  <TableCell>{location.grText}</TableCell>
                  <TableCell>{location.latitude}</TableCell>
                  <TableCell>{location.longitude}</TableCell>
                  <TableCell>
                    <IconButton>
                      <EditIcon
                        onClick={() => {
                          setEditedLocation(location)
                          setIsDialogOpen(true)
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
